import { useEffect } from "react";
import type { BottleClickerCoupon } from "@ziolo/shared";
import { Button } from "@ziolo/ui";
import { WyplataReceiptCard } from "./WyplataReceiptCard.js";
import { couponToReceipt, formatReceiptPln, formatReceiptStamp } from "./wyplataReceipt.js";

export function WyplataCouponDrawer({
  coupons,
  onClose,
  onZoom,
}: {
  coupons: readonly BottleClickerCoupon[];
  onClose: () => void;
  onZoom: (coupon: BottleClickerCoupon) => void;
}) {
  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      if (event.code === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="wyplata-drawer-overlay" role="dialog" aria-label="Historia kuponów" onClick={onClose}>
      <aside className="wyplata-drawer" onClick={(event) => event.stopPropagation()}>
        <header className="wyplata-drawer__head">
          <div>
            <h3 className="wyplata-drawer__title">Historia kuponów</h3>
            <p className="wyplata-drawer__hint">
              {coupons.length > 0
                ? "Kliknij miniaturę, żeby powiększyć kupon."
                : "Tu pojawią się kupony po wypłacie kaucji."}
            </p>
          </div>
          <Button size="sm" variant="ghost" onClick={onClose} aria-label="Zamknij">
            ✕
          </Button>
        </header>
        {coupons.length === 0 ? (
          <p className="wyplata-drawer__empty">Brak kuponów w schowku.</p>
        ) : (
          <ul className="wyplata-drawer__grid">
            {coupons.map((coupon) => {
              const data = couponToReceipt(coupon);
              return (
                <li key={`${coupon.txnId}-${coupon.printedAtMs}`}>
                  <button
                    type="button"
                    className="wyplata-mini"
                    onClick={() => onZoom(coupon)}
                    aria-label={`Kupon ${formatReceiptPln(coupon.runGrosze)}, wypłata ${coupon.prestigeCountAfter}`}
                  >
                    <span className="wyplata-mini__frame" aria-hidden="true">
                      <span className="wyplata-mini__scale">
                        <WyplataReceiptCard data={data} />
                      </span>
                    </span>
                    <span className="wyplata-mini__caption">
                      <strong>{formatReceiptPln(coupon.runGrosze)}</strong>
                      <span>{formatReceiptStamp(data.printedAt)}</span>
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </aside>
    </div>
  );
}
